module.exports = __webpack_public_path__ + "static/b9255aff1451fa7a82e9cdb4478d93c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/macbook.png
// module id = 1183
// module chunks = 0